import React from "react";
import PropTypes from "prop-types";
import ContentEditorView from "@components/ContentEditorView/index";
import StaticHTMLProductDescription from "@components/ProductPage/ProductDescription/StaticHTMLProductDescription";

const ContentEditorProductDescription = ({
  staticHTML,
  contentEditorBlock,
  ean,
  brand,
}) => {
  let contentEditorObject = null;

  try {
    contentEditorObject = JSON.parse(contentEditorBlock);
  } catch (error) {
    console.log(error);
  }

  return contentEditorObject ? (
    <ContentEditorView content={contentEditorObject} />
  ) : (
    <StaticHTMLProductDescription
      staticHTML={staticHTML}
      ean={ean}
      brand={brand}
    />
  );
};

ContentEditorProductDescription.propTypes = {
  staticHTML: PropTypes.string.isRequired,
  contentEditorBlock: PropTypes.string.isRequired,
  ean: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};

export default ContentEditorProductDescription;
